<template>
    <div class="people d-flex flex-column">
        <div>
            <div class="navigator">
                <h2 class="mr-auto">My Agents</h2>

                <invite></invite>
            </div>
        </div>

        <div class="flexGrow1 overflow-auto">
            <tabs>
                <tab name="">
                    <agents></agents>
                </tab>
            </tabs>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import Agents from './PeopleAgents'
    import Invite from './agents/AgentInviteButton'
    import Empty from '@/tools/Empty'

    export default {
        created() {
            // Refresh agent list
            this.downloadAgents();
        },
        methods: {
            ...mapActions([
                'refreshAccountData',
                'openNewMessageModal',
                'openModal',
                'downloadAgents'
            ]),
            triggerNewMessage() {
                this.openNewMessageModal('agent');
            },
        },
        components: {
            Agents,
            Empty,
            Invite,
        },
    }
</script>



// WEBPACK FOOTER //
// People.vue?a891254a